<template>
	<!-- This example requires Tailwind CSS v2.0+ -->
	<div
		:class="[open ? 'fixed inset-0 overflow-hidden z-50' : 'z-50']"
		aria-labelledby="slide-over-title"
		role="dialog"
		aria-modal="true"
	>
		<div class="absolute inset-0 overflow-hidden">
			<transition name="fade">
				<div
					class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
					v-on:click.stop="close()"
				></div>
			</transition>

			<transition name="slidein-right">
				<div class="fixed inset-y-0 right-0 pl-10 max-w-full flex" v-if="open">
					<div class="w-screen max-w-lg">
						<div
							class="h-full flex flex-col pt-4 bg-white shadow-xl overflow-y-scroll"
						>
							<div class="px-4 sm:px-6">
								<div class="flex items-start justify-between">
									<h2
										class="text-2xl font-semibold text-gray-900"
										id="slide-over-title"
									>
										{{ __(title) }}
									</h2>
									<div class="ml-3 h-7 flex items-center">
										<button
											type="button"
											class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
											v-on:click="close()"
										>
											<span class="sr-only">Close panel</span>
											<ui-icon
												class="text-orange-500 h-6 w-6"
												name="x"
												stroke-width="2"
											/>
										</button>
									</div>
								</div>
							</div>
							<div class="mt-4 relative flex-1">
								<slot>
									<!-- Replace with your content -->
									<div class="absolute inset-0">
										<div
											class="h-full border-2 border-dashed border-gray-200"
											aria-hidden="true"
										></div>
									</div>
									<!-- /End replace -->
								</slot>
							</div>
						</div>
					</div>
				</div>
			</transition>

			<slot name="custom" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: "Slideover Title",
		},
	},
	data() {
		return {
			open: false,
		};
	},
	mounted() {
		this.open = true;
	},
	methods: {
		close() {
			let that = this;
			setTimeout(function () {
				that.$emit("close");
			}, 300);
			this.$nextTick(function () {
				this.open = false;
			});
		},
	},
	beforeDestroy() {
		document.body.classList.remove("overflow-hidden");
	},
	watch: {
		open(isOpen) {
			if (isOpen) {
				document.body.classList.add("overflow-hidden");
			} else {
				document.body.classList.remove("overflow-hidden");
			}
		},
	},
};
</script>
